import type { Schema } from "@loanlink-nl/zero";
import type { Row } from "@rocicorp/zero";

export function getTitle(
	meeting: Pick<
		Row<Schema["tables"]["conversationTable"]>,
		"title" | "generatedTitle" | "displayId"
	>,
) {
	if (!meeting) {
		return "Gesprek";
	}

	if (meeting.title) {
		return meeting.title;
	}

	if (meeting.generatedTitle) {
		return meeting.generatedTitle;
	}

	if (meeting.displayId) {
		return `Gesprek ${meeting.displayId}`;
	}

	return "Gesprek";
}
